// extracted by mini-css-extract-plugin
module.exports = {"filtersContainer":"filterable-product-list-component_filtersContainer__23kFg","filterBtn":"filterable-product-list-component_filterBtn__2njW1"};